import React, {forwardRef, LegacyRef} from "react";
import SlideData, {UploadStatus} from "../../../Interfaces/SlideData";
import Loader from "../../Common/Loader";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setSlideUploadStatus} from "../../../store/makerDataSlice";
import * as Sentry from "@sentry/react";
import axios from "axios";

interface SlidesListItemProps {
    data: SlideData,
    index: number,
    onClickAction: (data: SlideData) => void,
    onAddSlideClick: () => void,
    onRotateSlide: (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => void,
    onEditSlide: (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => void,
    onDeleteSlide: (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => void,
    onDeleteAllSlides: (e: React.MouseEvent<HTMLElement>) => void,
}

const SlidesListItem: React.FC<SlidesListItemProps> = forwardRef(({
                                                                      data,
                                                                      index,
                                                                      onClickAction,
                                                                      onAddSlideClick,
                                                                      onRotateSlide,
                                                                      onEditSlide,
                                                                      onDeleteSlide,
                                                                      onDeleteAllSlides,
                                                                      ...props
                                                                  }, ref) => {

    const dispatch = useAppDispatch()
    const makerData = useAppSelector(state => state.makerData)

    const onThumbnailDownloaded = () => {
        dispatch(setSlideUploadStatus({
            pid: data.pid,
            status: UploadStatus.ready
        }));
    }

    const onThumbnailError = () => {
        dispatch(setSlideUploadStatus({
            pid: data.pid,
            status: UploadStatus.uploadError
        }));
    }

    const zoomInItem = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClickAction(data);
    }

    return (
        (
            data.pid === 'add-slide-item'
                ?
                <div
                    className="add-slide-item"
                    onClick={onAddSlideClick}
                    key={'add-slide'}
                >
                    <div className="plusChar">+</div>
                    <div className="text">Добавить фото<br/>или текст</div>
                    <div className={`delete-all-slides ${makerData.slides.length === 1 ? 'disabled' : ''}`}
                         onClick={(e) => {
                             e.stopPropagation();
                             if (makerData.slides.length > 1) {
                                 onDeleteAllSlides(e);
                             }
                         }}>
                        <i className={'fa fa-trash-alt'}></i>
                        <span className={'text'}>
                            Удалить все слайды
                        </span>
                    </div>
                </div>
                :
                <div
                    ref={ref as LegacyRef<any>}
                    className={`grid-item-slide ${data.status == UploadStatus.ready ? 'loaded' : ''} grid-item-slide-${data.type}`}
                    style={data.status == UploadStatus.uploadSuccess || data.status == UploadStatus.ready ? {backgroundImage: `url(${data.medium_url})`} : {}}
                    key={'slide-list-item-component-' + data.pid}
                    onClick={() => {
                        if (data.status == UploadStatus.ready) {
                            onClickAction(data)
                        }
                    }}
                >
                    {
                        (data.status == UploadStatus.uploadSuccess || data.status == UploadStatus.ready) ?
                            (
                                <img src={data.medium_url}
                                     key={'slide-list-item-component-image-' + data.pid}
                                     className={'blur5'}
                                     onLoad={onThumbnailDownloaded}
                                     onError={(e) => {
                                         let src = (e.target as HTMLImageElement).src;
                                         console.log(src);
                                         let url = new URL(src);
                                         if (!url.searchParams.has('i') || (url.searchParams.has('i') && parseInt(url.searchParams.get('i') ?? '') < 15)) {
                                             url.searchParams.set('r', (new Date()).getTime().toString());
                                             url.searchParams.set('i', url.searchParams.has('i') ? (parseInt(url.searchParams.get('i') ?? '') + 1).toString() : '1');
                                             console.log('new url: ' + url.toString());
                                             setTimeout(() => {
                                                 console.log('set new src after timeout');
                                                 (e.target as HTMLImageElement).src = url.toString();
                                             }, 1000);
                                         } else {
                                             onThumbnailError();
                                             // create test axios request
                                             axios.get((e.target as HTMLImageElement).src)
                                                 .then((response) => {
                                                     Sentry.captureException(
                                                         new Error('Failed to load uploaded photo to client.'),
                                                         {
                                                             extra: {
                                                                 src: (e.target as HTMLImageElement).src,
                                                                 testAxiosError: 'no error',
                                                                 responseHeaders: response.headers
                                                             }
                                                         }
                                                     );
                                                 })
                                                 .catch(error => {
                                                     Sentry.captureException(
                                                         new Error('Failed to load uploaded photo to client.'),
                                                         {
                                                             extra: {
                                                                 src: (e.target as HTMLImageElement).src,
                                                                 axiosError: JSON.stringify(error)
                                                             }
                                                         }
                                                     );
                                                 })
                                             // Sentry.captureException(
                                             //     new Error('Failed to load uploaded photo to client.'),
                                             //     {
                                             //         extra: {src: (e.target as HTMLImageElement).src}
                                             //     }
                                             // );
                                         }
                                     }}
                                />
                            ) : ''
                    }

                    {
                        (data.status == UploadStatus.uploadError) ?
                            (
                                <div className={'upload-error-container'}>
                                    <div className={'upload-error'}>
                                        <div className={'upload-error-text'}>{data.uploadError}</div>
                                        <div className={'local-file-name'}>{data.localFileName}</div>
                                    </div>
                                    <div className={'over'} style={{opacity: 1}}>
                                        <div className={'control delete'}
                                             onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                 onDeleteSlide(e, data)
                                             }}>
                                            <i className={'fa fa-trash-alt'}></i>
                                        </div>
                                    </div>
                                </div>
                            ) : ''
                    }

                    {
                        (data.status == UploadStatus.uploading || data.status == UploadStatus.uploadSuccess) ?
                            (
                                <Loader showProgress={true}
                                        progress={data.uploadProgress as number}
                                        isLoaded={false}
                                        background={'#efefef7a'}/>
                            ) : ''
                    }

                    {
                        (data.status == UploadStatus.ready) ?
                            (
                                <div className={'over'}>
                                    <div className={'control zoomIn'}
                                         onClick={zoomInItem}>
                                        <i className={'fa fa-search-plus'}></i>
                                    </div>
                                    {
                                        /* Открытки-картинки нельзя вращать. если src содержит .slide-life.ru/cards/ - значит это открытка-картинка */
                                        data.type == 'photo' && !data.src?.includes('.slide-life.ru/cards/') ?
                                            (<div className={'control rotate'}
                                                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                      dispatch(setSlideUploadStatus({
                                                          pid: data.pid,
                                                          status: UploadStatus.uploadSuccess
                                                      }));
                                                      onRotateSlide(e, data);
                                                  }}>
                                                <i className={'fa fa-redo'}></i>
                                            </div>) : ''
                                    }
                                    {
                                        data.type == 'text' ?
                                            (<div className={'control edit'}
                                                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                      onEditSlide(e, data);
                                                  }}>
                                                <i className={'fa fa-pen'}></i>
                                            </div>) : ''
                                    }
                                    <div className={'control delete'}
                                         onClick={(e: React.MouseEvent<HTMLElement>) => {
                                             onDeleteSlide(e, data)
                                         }}>
                                        <i className={'fa fa-trash-alt'}></i>
                                    </div>
                                    <div className={'control move'}>
                                        <i className={'fa fa-arrows-alt'}></i>
                                    </div>
                                </div>
                            ) : ''
                    }
                    {/*<div className={'drag-pressed'}>*/}
                    {/*    <i className={'fa fa-arrows-alt'}></i>*/}
                    {/*</div>*/}
                    <span className="index">{index + 1}</span>
                </div>
        )
    );
})

export default SlidesListItem;